// extracted by mini-css-extract-plugin
export default {"parent":"PlayModeButtons_parent__zQ71t","playMode__timer":"PlayModeButtons_playMode__timer__BzHyn","playMode__timer__title":"PlayModeButtons_playMode__timer__title__AalJl"};